import AbstractBaseError from './AbstractBaseError';

export default class NotificationException extends AbstractBaseError {
    name = 'NotificationException';

    shouldBeRetried = false;

    shouldBeReported = false;
}
